import { useEffect, useState, useCallback } from "react";
import { ethers } from "ethers";
import marketplaceAbi from "../abis/NFTMarketplace.json";

const MARKETPLACE_ADDRESS = "0x0cCC053bA17A822e073A8F4c057a23922ee0B161";

function MarketplaceFees({ signer }) {
  const [fees, setFees] = useState("0");

  const fetchFees = useCallback(async () => {
    try {
      const provider = new ethers.BrowserProvider(window.ethereum);
      const marketplace = new ethers.Contract(MARKETPLACE_ADDRESS, marketplaceAbi.abi, provider);
      const balance = await marketplace.totalFees();
      setFees(ethers.formatEther(balance));
    } catch (error) {
      console.error(error);
    }
  }, []);

  const handleWithdraw = async () => {
    try {
      const marketplace = new ethers.Contract(MARKETPLACE_ADDRESS, marketplaceAbi.abi, signer);
      await marketplace.withdrawFees();
      alert("✅ 수수료 수령 완료!");
      fetchFees();
    } catch (error) {
      console.error(error);
      alert("❌ 수수료 수령 실패: " + error.message);
    }
  };

  useEffect(() => {
    fetchFees();
  }, [fetchFees]);

  return (
    <div className="component-card">
      <h3 style={{ textAlign: 'center', marginBottom: 12 }}>💰 수수료 조회</h3>
      <p style={{ textAlign: 'center', marginBottom: 16 }}>현재까지 모인 수수료: {fees} KAIA</p>
      <div style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
        <button className="component-btn" onClick={handleWithdraw}>수수료 수령</button>
      </div>
    </div>
  );
}

export default MarketplaceFees;
